import { format, parseISO } from "date-fns";

/**
 * Форматує дату з ISO формату (YYYY-MM-DD) в формат DD.MM.YYYY
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  
  try {
    const date = parseISO(dateString);
    return format(date, "dd.MM.yyyy");
  } catch {
    // Якщо не вдалося розпарсити, повертаємо оригінальний рядок
    return dateString;
  }
};
